import { useState } from "react";

import { Button } from 'react-bootstrap';
import ReactModal from 'react-modal';

ReactModal.setAppElement('*');

export const ModalUpdatePoolSchedule = ({ ynmOpen, ynmQuestionText, ynmNoText, ynmYesText, ynmNoFunction, ynmYesFunction }) => {

	const [enteredPlayerName, setEnteredPlayerName] = useState('');

	const grabPlayerNameInput = (event) => {
		setEnteredPlayerName(event.target.value);
	};
	
	const resolveInputs = () => {
		if (enteredPlayerName !== '') {
			return enteredPlayerName;
		}
		return undefined;
	};

	return (
		<div>
			<ReactModal isOpen={ynmOpen} appElement={document.getElementById('app')}
              style={{
                overlay: {
                  position: 'fixed',
                  zIndex: 1020,
                  top: 0,
                  left: 0,
                  width: '100vw',
                  height: '100vh',
                  background: 'rgba(128, 255, 255, 0.75)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                },
                content: {
                  background: 'white',
                  width: '45rem',
                  maxWidth: 'calc(100vw - 2rem)',
                  maxHeight: 'calc(100vh - 2rem)',
                  overflowY: 'auto',
                  position: 'relative',
                  border: '1px solid #ccc',
                  borderRadius: '0.3rem',
                }}}
              >
				{ynmQuestionText}<br />
				<br />
				New Schedule:<br /><textarea placeholder='Schedule Text' value={enteredPlayerName} rows={10} cols={60} onChange={grabPlayerNameInput} />
				<br />
				<br />
				<Button variant="primary" onClick={() => ynmYesFunction(resolveInputs() )}>{ynmYesText}</Button>&nbsp;&nbsp;&nbsp;
				<Button variant="secondary" onClick={ynmNoFunction}>{ynmNoText}</Button>
			</ReactModal>
		</div>
	);

};
